import React from "react";

const ErrorNotification = ({ message, onClose }) => {
  return (
    
          <div className="textbox">
    <div className="error-notification">
      <p>{message}</p>
      <button onClick={onClose}>Close</button>
    </div></div>
  );
};

export default ErrorNotification;
